import { defined } from "common/Support";
import * as React from "react";
import { withTheme } from "styled-components";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import { styled } from "../../../styled-components";

// Surely there is a better way built into JS
function dateString(): string {
    let hours = new Date().getHours();
    let minutes = new Date().getMinutes().toString();

    if (hours > 12) hours = hours - 12;
    if (hours === 0) hours = 12;

    if (minutes.length === 1) minutes = "0" + minutes;
    return hours + ":" + minutes;
}

const AndroidStatusBarWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: black;
    color: white;
    height: 24px;
    width: 100%;
    padding-right: 16px;
`;

function AndroidStatusBar() {
    return (
        <AndroidStatusBarWrapper>
            <svg width="57" height="16" viewBox="0 0 57 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M50 1.875V1L47 1V1.875H44V15H53V1.875H50Z"
                    fill="white"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M21 15H35V1L21 15Z" fill="white" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.977295 4.01593L9.99992 15L19.0226 4.01593C16.5117 2.12256 13.3869 1 9.99992 1C6.61294 1 3.48814 2.12256 0.977295 4.01593Z"
                    fill="white"
                />
            </svg>
            {dateString()}
        </AndroidStatusBarWrapper>
    );
}

function StatusBarDrawing(props: { theme: RuntimeTheme }) {
    const time = dateString();
    // these artisnal tuned constants brought to you by taking screenshots and measuring
    let timeX = 30;
    if (time.length > 4) {
        timeX -= 9;
    }

    const width = props.theme.builderWidth;
    // Assumes that values greater than 375 are going to be shown the tablet status bar.
    if (width <= 375) {
        return (
            <svg width="375" height="44" viewBox="0 0 375 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M290.327 19C289.742 19 289.267 19.4748 289.267 20.0605V29.1889C289.267 29.7746 289.742 30.2494 290.327 30.2494H291.42C292.006 30.2494 292.481 29.7746 292.481 29.1889V20.0605C292.481 19.4748 292.006 19 291.42 19H290.327Z" />
                <path d="M284.178 22.4712C284.178 21.8855 284.653 21.4106 285.239 21.4106H286.332C286.918 21.4106 287.392 21.8855 287.392 22.4712V29.1889C287.392 29.7746 286.918 30.2494 286.332 30.2494H285.239C284.653 30.2494 284.178 29.7746 284.178 29.1889V22.4712Z" />
                <path d="M280.15 24.089C279.564 24.089 279.089 24.5638 279.089 25.1495V29.1888C279.089 29.7745 279.564 30.2493 280.15 30.2493H281.243C281.828 30.2493 282.303 29.7745 282.303 29.1888V25.1495C282.303 24.5638 281.828 24.089 281.243 24.089H280.15Z" />
                <path d="M275.061 26.2318C274.475 26.2318 274 26.7066 274 27.2923V29.1889C274 29.7746 274.475 30.2494 275.061 30.2494H276.154C276.739 30.2494 277.214 29.7746 277.214 29.1889V27.2923C277.214 26.7066 276.739 26.2318 276.154 26.2318H275.061Z" />
                <path d="M315.983 22.2965L315.976 22.0463C313.781 20.0828 310.962 19 308 19C305.03 19 302.204 20.0889 300.007 22.0625L300 22.3125L301.299 23.6138L301.534 23.6214C303.322 22.0477 305.604 21.1816 308 21.1816C310.388 21.1816 312.663 22.0418 314.449 23.6059L314.683 23.5981L315.983 22.2965Z" />
                <path d="M313.128 24.8916L313.139 25.1451L311.836 26.4504L311.607 26.4633C310.583 25.6451 309.32 25.2003 308 25.2003C306.672 25.2003 305.402 25.6505 304.375 26.4779L304.146 26.4655L302.843 25.1606L302.854 24.9074C304.291 23.6871 306.102 23.0187 308 23.0187C309.89 23.0187 311.693 23.6811 313.128 24.8916Z" />
                <path d="M308.105 30.1878H307.862L305.7 28.0225C305.625 27.947 305.636 27.8216 305.723 27.76C306.388 27.2896 307.178 27.0374 308 27.0374C308.814 27.0374 309.596 27.2843 310.257 27.7455C310.345 27.8068 310.356 27.9327 310.281 28.0086L308.105 30.1878Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M344.777 19H326.664C325.193 19 324 20.1926 324 21.6638V28.5896C324 30.0608 325.193 31.2534 326.664 31.2534H344.777C346.249 31.2534 347.441 30.0608 347.441 28.5896V21.6638C347.441 20.1926 346.249 19 344.777 19ZM325.065 21.6639C325.065 20.7812 325.781 20.0656 326.664 20.0656H344.777C345.66 20.0656 346.376 20.7812 346.376 21.6639V28.5897C346.376 29.4724 345.66 30.188 344.777 30.188H326.664C325.781 30.188 325.065 29.4724 325.065 28.5897V21.6639Z"
                />
                <path d="M349.839 24.8604C349.839 23.8744 349.303 23.0136 348.507 22.553V27.1678C349.303 26.7072 349.839 25.8464 349.839 24.8604Z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M327.196 21.1311H344.245C344.833 21.1311 345.31 21.6082 345.31 22.1967V28.057C345.31 28.6454 344.833 29.1225 344.245 29.1225H327.196C326.608 29.1225 326.131 28.6454 326.131 28.057V22.1967C326.131 21.6082 326.608 21.1311 327.196 21.1311Z"
                />
                <path d="M71.3832 31.3915C70.9406 32.3736 69.4715 32.0578 69.4715 30.9806V26.5105H65.0014C63.9242 26.5105 63.6084 25.0415 64.5904 24.5989L74.5496 20.1097C75.3892 19.7313 76.2506 20.5928 75.8722 21.4323L71.3832 31.3915Z" />
                <text
                    fontFamily="-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif"
                    fontSize="16px"
                    fontWeight="500"
                    x={timeX}
                    y="32">
                    {`${dateString()}`}
                </text>
                <path
                    d="M106.97 0H268.058V0C265.363 0 263.177 2.18537 263.177 4.88115L263.177 12C263.177 22.4934 254.671 31 244.177 31L130.292 31C119.799 31 111.292 22.4934 111.292 12L111.292 4.32211C111.292 1.93507 109.357 0 106.97 0V0Z"
                    fill="black"
                />
            </svg>
        );
    } else {
        const translateTablet = `translate(-170, 0)`;

        return (
            <svg width={width} height="24" viewBox={`0 0 ${width} 24`} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    transform={translateTablet}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1173.5 6.50001H1156.5C1155.12 6.50001 1154 7.6193 1154 9.00001V15.5C1154 16.8807 1155.12 18 1156.5 18H1173.5C1174.88 18 1176 16.8807 1176 15.5V9.00001C1176 7.6193 1174.88 6.50001 1173.5 6.50001ZM1155 9.00012C1155 8.17169 1155.67 7.50012 1156.5 7.50012H1173.5C1174.33 7.50012 1175 8.17169 1175 9.00012V15.5001C1175 16.3285 1174.33 17.0001 1173.5 17.0001H1156.5C1155.67 17.0001 1155 16.3285 1155 15.5001V9.00012ZM1178.25 12.0001C1178.25 11.0747 1177.75 10.2668 1177 9.83455V14.1656C1177.75 13.7334 1178.25 12.9255 1178.25 12.0001Z"
                />
                <path
                    transform={translateTablet}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1157 8.50011H1173C1173.55 8.50011 1174 8.94783 1174 9.50011V15.0001C1174 15.5524 1173.55 16.0001 1173 16.0001H1157C1156.45 16.0001 1156 15.5524 1156 15.0001V9.50011C1156 8.94783 1156.45 8.50011 1157 8.50011Z"
                />

                <path
                    transform={translateTablet}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1129.37 9.69885L1129.37 9.464C1127.31 7.62122 1124.66 6.605 1121.88 6.605C1119.09 6.605 1116.44 7.627 1114.38 9.4792L1114.37 9.71384L1115.59 10.9352L1115.81 10.9423C1117.49 9.46527 1119.63 8.65246 1121.88 8.65246C1124.12 8.65246 1126.26 9.45975 1127.93 10.9277L1128.15 10.9204L1129.37 9.69885ZM1126.69 12.1343L1126.7 12.3723L1125.48 13.5974L1125.27 13.6094C1124.3 12.8415 1123.12 12.4241 1121.88 12.4241C1120.63 12.4241 1119.44 12.8466 1118.48 13.6231L1118.26 13.6115L1117.04 12.3868L1117.05 12.1492C1118.4 11.0039 1120.1 10.3766 1121.88 10.3766C1123.65 10.3766 1125.35 10.9983 1126.69 12.1343ZM1121.98 17.105H1121.75L1119.72 15.0728C1119.65 15.0019 1119.66 14.8842 1119.74 14.8264C1120.37 14.385 1121.11 14.1482 1121.88 14.1482C1122.64 14.1482 1123.38 14.38 1124 14.8127C1124.08 14.8703 1124.09 14.9885 1124.02 15.0597L1121.98 17.105Z"
                />
                <path
                    transform={translateTablet}
                    d="M1142.91 16.2848C1142.7 16.7829 1141.96 16.629 1141.96 16.0862V13.0449C1141.96 12.7688 1141.73 12.5449 1141.46 12.5449H1138.41C1137.87 12.5449 1137.72 11.8016 1138.22 11.5861L1145.34 8.5019C1145.76 8.32192 1146.18 8.74355 1146 9.15938L1142.91 16.2848Z"
                />
                <text
                    fontFamily="-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif"
                    fontSize="14px"
                    fontWeight="normal"
                    x={timeX}
                    y="18">
                    {`${dateString()}`}
                </text>
            </svg>
        );
    }
}

const StatusBarContainer = styled.div<{ drawBackground: boolean }>`
    background-color: ${p => (p.drawBackground ? p.theme.navBar.bgColor : "transparent")};
    width: 100%;
    z-index: 45;
    position: sticky;
    height: ${p => p.theme.statusBar.height}px;
    font-family: "Roboto";

    svg {
        fill: ${p => p.theme.statusBar.color};
    }
`;

interface Props {
    theme: RuntimeTheme;
    isSplash: boolean;
}

class StatusBar extends React.Component<Props> {
    private interval: number = 0;

    public componentDidMount() {
        this.interval = window.setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    public componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    public render() {
        const isIOS = defined(this.props.theme).navBar.style === "iOS";
        const content = isIOS ? <StatusBarDrawing theme={this.props.theme} /> : <AndroidStatusBar />;
        return <StatusBarContainer drawBackground={!isIOS && !this.props.isSplash}>{content}</StatusBarContainer>;
    }
}

export default withTheme(StatusBar);
